/**
 * Liste des champs qui bloquent le passage à l'étape suivante (lot Z2).
 *
 * Remplace `alert('Veuillez remplir tous les champs obligatoires…')` : l'alerte suspendait
 * tout le JavaScript (page figée, prise pour un plantage) et ne disait pas QUOI remplir.
 */
import React from 'react';

const ChampsManquants = ({ champs, variant = 'inline', testId = 'wizard-champs-manquants' }) => {
  if (!champs || champs.length === 0) return null;
  const texte = `Renseignez : ${champs.join(', ')}`;

  if (variant === 'banner') {
    return (
      <div
        data-testid={testId}
        role="alert"
        className="mb-4 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3"
      >
        <i className="bi bi-exclamation-triangle-fill text-amber-600 mt-0.5" />
        <div className="text-sm text-amber-900">
          <span className="font-semibold">Impossible de continuer.</span> {texte}
        </div>
      </div>
    );
  }

  return (
    <p data-testid={testId} className="mt-2 text-xs text-amber-700 text-right">
      <i className="bi bi-exclamation-triangle-fill mr-1" />
      {texte}
    </p>
  );
};

export default ChampsManquants;
